<template>
  <div id="material-kit">
    <div :class="{ 'nav-open': NavbarStore.showNavbar }">
      <router-view name="header" v-if="!loading"/>
      <div>
        <Loader v-if="loading" />
        <router-view :key="$route.fullPath" :header_pictures=header_pictures v-else/>
      </div>
      <router-view name="footer" v-if="!loading"/>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader.vue";
export default {
  name: 'App',
  data() {
    return {
      header_pictures: {},
      categories: [],
      loading: true,
    }
  },
  components: {
    Loader
  },
  mounted() {
    axios.get("https://strapi-asiongs.herokuapp.com/header-pictures", {}).then(
      (response) => {
        this.header_pictures = response.data;
        this.loading=false;
      },
      (error) => {
        // console.log(error);
      }
    );
  },
  metaInfo: {
    // title: 'Asiongs Industrial Products',
    titleTemplate: "%s - Asiong's Industrial Products",
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { property: 'og:type', content: 'website'},    
      { name: 'robots', content: 'index,follow'}
    ]
  }
}
</script>
